export default class FilterAreaUtils {
  static getFilterType(
    isEditable: boolean,
    isGlobal: boolean
  ): 'predefined' | 'personal' | 'global' {
    if (!isEditable) {
      return 'predefined';
    }

    if (isGlobal) {
      return 'global';
    }

    return 'personal';
  }
}
